// Lista negra no WootDash (substitui list_blacklist/add_blacklist_contact do n8n).
// Todo agente logado lê a lista (o painel esconde as conversas desses contatos). Bloquear, desbloquear e ver a aba
// "Bloqueados" exige blacklist.manage (Supervisor, Administrador, Sistema). A etiqueta "lista-negra" numa conversa
// também bloqueia, no backend. Bloqueio é em silêncio: o contato não recebe resposta e o que ele mandar só fica
// guardado na aba "Bloqueados".
import { WOOTDASH_BASE, wootdashAuthHeaders } from '@/api/wootdash'

export interface BlockedContact {
  id: string
  name: string
  phone: string | null
  reason: string | null
  blockedAt: string | null
  /** Mensagens que ele tentou mandar desde o bloqueio atual (guardadas, nunca entregues). */
  messagesSinceBlock: number
  lastMessageAt: string | null
  /** Só na resposta de bloquear: quantas conversas abertas foram encerradas. */
  closedConversations: number
}

export interface BlockedMessage {
  id: number
  contactId: string
  contactName: string
  contactPhone: string | null
  messageType: string
  body: string | null
  mediaUrl: string | null
  mediaMimeType: string | null
  receivedAt: string
}

export interface BlockHistoryEntry {
  action: 'blocked' | 'unblocked'
  at: string
  actorId: string | null
  /** Nulo = automático (sem agente). */
  actorName: string | null
  reason: string | null
  /** manual | etiqueta */
  source: string | null
  closedConversations: number | null
}

export async function listBlockedContacts(token: string): Promise<BlockedContact[]> {
  try {
    const res = await fetch(`${WOOTDASH_BASE}/contatos/bloqueados`, { headers: wootdashAuthHeaders(token) })
    return res.ok ? await res.json() : []
  } catch {
    return []
  }
}

/** Bloqueia/desbloqueia. Devolve o contato atualizado (com quantas conversas foram encerradas) ou null se falhou. */
export async function setContactBlocked(token: string, contactId: string, blocked: boolean, reason?: string): Promise<BlockedContact | null> {
  try {
    const res = await fetch(`${WOOTDASH_BASE}/contatos/${contactId}/${blocked ? 'bloquear' : 'desbloquear'}`, {
      method: 'POST',
      headers: { ...wootdashAuthHeaders(token), 'Content-Type': 'application/json' },
      body: blocked ? JSON.stringify({ motivo: reason ?? null }) : undefined,
    })
    return res.ok ? await res.json() : null
  } catch {
    return null
  }
}

/** Aba "Bloqueados": o que contatos bloqueados mandaram. null = sem permissão ou erro. */
export async function listBlockedMessages(token: string, contactId?: string): Promise<BlockedMessage[] | null> {
  try {
    const query = contactId ? `?contato=${contactId}` : ''
    const res = await fetch(`${WOOTDASH_BASE}/contatos/bloqueados/mensagens${query}`, { headers: wootdashAuthHeaders(token) })
    return res.ok ? await res.json() : null
  } catch {
    return null
  }
}

export async function getBlockHistory(token: string, contactId: string): Promise<BlockHistoryEntry[]> {
  try {
    const res = await fetch(`${WOOTDASH_BASE}/contatos/${contactId}/bloqueio/historico`, { headers: wootdashAuthHeaders(token) })
    return res.ok ? await res.json() : []
  } catch {
    return []
  }
}
